export enum FP_VOUCHER_TYPES {
    FreeSpin =  '1',
    FreePlay = '2',
    FreeJackpotSpin = '3',
    FreeJackpotPlay = '4'
}
